import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { AppService } from '@shared/services/app.service';

@Component({
  selector: 'app-profile-survey-card',
  templateUrl: './survey-card.component.html',
  styleUrls: ['./survey-card.component.scss'],
})
export class SurveyCardComponent {
  @Input() surveyLink: string;
  @Output() getSurveyLink = new EventEmitter();

  constructor(
    readonly platformService: PlatformService,
    private appService: AppService,
  ) {}

  async openSurvey() {
    const isDesktop =
      this.platformService.platformType ===
      this.platformService.platformEnum.desktop;
    if (this.surveyLink && this.surveyLink !== '')
      if (isDesktop) {
        window.open(this.surveyLink, '_blank');
      } else {
        this.appService.openUrlInBrowser(this.surveyLink);
      }
  }
}
